import type {TFICDocument} from '../types/Document';
import {DocumentPreview} from './DocumentPreview';

const BODY_LINE_WIDTHS = ['w-full', 'w-11/12', 'w-9/12', 'w-full', 'w-10/12', 'w-7/12'];

function PageContents({tone}: {tone: 'faint' | 'strong'}) {
    const block = tone === 'faint' ? 'bg-gray-100' : 'bg-gray-400';
    const line = tone === 'faint' ? 'bg-gray-100' : 'bg-gray-300';

    return (
        <div className="h-full w-full p-4">
            <div className="flex items-start justify-between">
                <div className={`h-5 w-5 rounded ${block}`} />
                <div className="space-y-1">
                    <div className={`h-1.5 w-12 rounded-sm ${line}`} />
                    <div className={`h-1.5 w-8 rounded-sm ${line} ml-auto`} />
                </div>
            </div>

            <div className="mt-5 space-y-1.5">
                <div className={`h-1.5 w-16 rounded-sm ${block}`} />
                <div className={`h-1.5 w-20 rounded-sm ${line}`} />
            </div>

            <div className="mt-5 space-y-1.5">
                {BODY_LINE_WIDTHS.map((width, index) => (
                    <div key={index} className={`h-1.5 ${width} rounded-sm ${line}`} />
                ))}
            </div>

            <div className="mt-5 flex justify-end">
                <div className={`h-2 w-14 rounded-sm ${block}`} />
            </div>
        </div>
    );
}

export function PendingNotice({document}: {document: TFICDocument}) {
    return (
        <div className="flex min-h-0 w-full flex-1 gap-4 p-4">
            <div className="w-1/2 flex flex-col items-center justify-center px-8">
                <div className="relative aspect-[1/1.414] w-44 overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
                    <PageContents tone="faint" />
                    <div className="absolute inset-0 animate-document-extract motion-reduce:animate-none">
                        <PageContents tone="strong" />
                    </div>
                    <div aria-hidden="true" className="pointer-events-none absolute inset-0 motion-reduce:hidden">
                        <div className="h-full w-full animate-document-scan">
                            <div className="h-8 w-full bg-gradient-to-b from-transparent via-primary/30 to-transparent" />
                            <div className="h-px w-full bg-primary/50" />
                        </div>
                    </div>
                </div>

                <h2 className="mt-6 text-base font-semibold text-gray-900">Document wordt verwerkt</h2>
                <p className="mt-1 text-center text-sm text-gray-600">
                    We lezen de gegevens uit dit document. Straks staan ze hier ingevuld.
                </p>
            </div>

            <div className="flex min-h-0 w-1/2 overflow-hidden rounded-xl border border-gray-200 bg-gray-100">
                <DocumentPreview document={document} />
            </div>
        </div>
    );
}
